import { render, staticRenderFns } from "./App_MegaMenu.vue?vue&type=template&id=8d834f2c&"
import script from "./App_MegaMenu.vue?vue&type=script&lang=js&"
export * from "./App_MegaMenu.vue?vue&type=script&lang=js&"
import style0 from "./App_MegaMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports